const L = console.log

export class Events {

    static plain (e: any) : boolean {
        return e && !e.shiftKey && !e.altKey && !e.ctrlKey && !e.metaKey
    }

    static ctrl (e: any) : boolean {
        return e && !!e.ctrlKey && !e.shiftKey && !e.altKey && !e.metaKey
    }

    static shift (e: any) : boolean {
        return e && !!e.shiftKey && !e.altKey && !e.ctrlKey&& !e.metaKey
    }

    static cmd (e: any) : boolean {
        return e && !!e.metaKey && !e.shiftKey && !e.ctrlKey&& !e.altKey
    }

    static alt (e: any) : boolean {
        return e && !!e.altKey && !e.shiftKey && !e.ctrlKey && !e.metaKey
    }
}